<template>
  <defs>
    <!-- Soft inner shadow to give the arc a sense of depth, inspired by the filters used in the static VisChart SVG. -->
    <filter
      id="radialBarInnerShadow"
      x="-50%"
      y="-50%"
      width="200%"
      height="200%"
      color-interpolation-filters="sRGB"
    >
      <feFlood
        flood-opacity="0"
        result="BackgroundImageFix"
      />
      <feBlend
        in="SourceGraphic"
        in2="BackgroundImageFix"
        result="shape"
      />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <!-- Slight offset and blur for a subtle inset effect -->
      <feOffset dy="1" />
      <feGaussianBlur stdDeviation="1" />
      <feComposite
        in2="hardAlpha"
        operator="arithmetic"
        k2="-1"
        k3="1"
      />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
      />
      <feBlend
        in2="shape"
        result="effect1_innerShadow"
      />
    </filter>
  </defs>
</template>
